import { A as e } from "./index-isgVnOkQ.mjs";
import { a as r } from "./icon-CvGUqXUP.mjs";
function n() {
  return e.get(r).then((t) => t.data).catch(() => (console.error("Unable to retrieve icon manifest"), {}));
}
function c() {
  return n().then((t) => Object.keys(t).sort());
}
export {
  c as g
};
//# sourceMappingURL=get-icon-names-DJAFys0G.mjs.map
